export const GenieAcsSkeletonCardComponent = () => (
    <div
        className="rounded-2xl p-5 animate-pulse"
        style={{
            background: "rgba(15, 23, 42, 0.5)",
            border: "1px solid rgba(51, 65, 85, 0.3)",
        }}
    >
        <div className="flex justify-between items-start mb-4">
            <div className="space-y-2">
                <div className="h-4 bg-slate-700/60 rounded-md w-32" />
                <div className="h-3 bg-slate-700/40 rounded-md w-24" />
            </div>
            <div className="h-6 bg-slate-700/40 rounded-full w-16" />
        </div>
        <div
            className="space-y-2 pt-3"
            style={{ borderTop: "1px solid rgba(51, 65, 85, 0.2)" }}
        >
            <div className="h-3 bg-slate-700/50 rounded w-full" />
            <div className="h-3 bg-slate-700/30 rounded w-3/4" />
        </div>
    </div>
);